import React from 'react'
import { FileInfoDTO } from 'interfaces/files/fileInfo'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { DownloadLinkChip } from '../chip/DownloadLinkChip'
import { EmptyValueRenderer } from 'components/EmptyValueRenderer'
import { theme } from '@ketch-com/deck'
import dayjs from 'dayjs'

type Props = {
  attachments: FileInfoDTO[]
  showAttachmentDetails?: boolean
}

interface FileInfoDTOWithMeta extends FileInfoDTO {
  createdAt?: number
  createdBy?: {
    email: string
    firstName?: string
    lastName?: string
    id?: string
  }
}

export const AttachmentsList: React.FC<Props> = ({ attachments, showAttachmentDetails = false }) => {
  return (
    <Box>
      {!!attachments.length ? (
        attachments.map((attachment: FileInfoDTOWithMeta) => (
          <>
            <Box display="flex" alignItems="center" key={attachment?.name} py={0.875}>
              <DownloadLinkChip
                fileName={attachment?.name}
                contentType={attachment?.content_type}
                downloadUrl={attachment?.download_url}
              />
            </Box>
            {showAttachmentDetails && (
              <Stack direction="row" sx={{ pb: 1 }}>
                <Typography color={theme.palette.Text.Secondary} whiteSpace="nowrap">
                  {`File Size: ${attachment.size}`}
                </Typography>
                <Box>
                  <Divider orientation="vertical" sx={{ mx: 1 }} />
                </Box>
                <Typography color={theme.palette.Text.Secondary} whiteSpace="nowrap">
                  {`Uploaded ${
                    attachment?.createdAt ? dayjs(attachment.createdAt * 1000).format('MMM D, YYYY, h:mm A') : ''
                  } by ${attachment?.createdBy?.firstName || ''} ${attachment?.createdBy?.lastName || ''}`}
                </Typography>
              </Stack>
            )}
          </>
        ))
      ) : (
        <EmptyValueRenderer />
      )}
    </Box>
  )
}
